module.exports = __webpack_public_path__ + "assets/static/png/shakhtar_fanid_prepaid.3bfaec9ffb344cbfcbb9c11fc4afe5a7.png";


/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/myCards/images/shakhtar_fanid_prepaid.png
 ** module id = 504
 ** module chunks = 1
 **/